import { useEffect } from 'react';

const FacebookErrorBoundary = () => {
  useEffect(() => {
    // Suppress Facebook SDK errors that bubble as unhandled rejections
    // (e.g. impression.php blocked by ad blockers, SDK loading failures)
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const message = event.reason?.message ?? String(event.reason ?? '');
      if (
        message.includes('impression.php') ||
        message.includes('ERR_BLOCKED_BY_CLIENT') ||
        message.includes('sdk.js') ||
        (message.includes('Failed to fetch') &&
          typeof event.reason?.stack === 'string' &&
          event.reason.stack.includes('facebook'))
      ) {
        event.preventDefault();
        // eslint-disable-next-line no-console
        console.debug('Suppressed Facebook SDK error:', message);
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    return () => window.removeEventListener('unhandledrejection', handleUnhandledRejection);
  }, []);

  return null;
};

export { FacebookErrorBoundary };
